"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const date_filter_picker_types_1 = require("../../model/date-filter-picker-types");
const date_filter_default_value_types_1 = require("../../model/date-filter-default-value-types");
const week_filter_item_1 = require("../../model/week-filter-item");
const year_filter_item_1 = require("../../model/year-filter-item");
const quarter_filter_item_1 = require("../../model/quarter-filter-item");
const semi_annual_filter_item_1 = require("../../model/semi-annual-filter-item");
const month_filter_item_1 = require("../../model/month-filter-item");
const idm_filtering_controls_1 = require("@synisys/idm-filtering-controls");
const operators_1 = require("rxjs/operators");
const path_processing_helper_1 = require("../../../../shared/path-processing-helper");
let DateFilterComponent = class DateFilterComponent {
    constructor() {
        this.datePickerTypes = date_filter_picker_types_1.DateFilterPickerTypes;
        this.datePickerDefaultValueTypes = date_filter_default_value_types_1.DateFilterDefaultValueTypes;
        this.isSelectControl = false;
        this.showLabel = true;
        this.viewMode = true;
    }
    ngOnInit() {
        this.isSelectControl =
            this.filterItem instanceof week_filter_item_1.WeekFilterItem ||
                this.filterItem instanceof month_filter_item_1.MonthFilterItem ||
                this.filterItem instanceof year_filter_item_1.YearFilterItem ||
                this.filterItem instanceof quarter_filter_item_1.QuarterFilterItem ||
                this.filterItem instanceof semi_annual_filter_item_1.SemiAnnualFilterItem;
        if (this.isSelectControl) {
            this.initValues();
        }
    }
    ngOnChanges(changes) {
        const filterItemChange = changes['filterItem'];
        const valueLoaderChange = changes['valueLoader'];
        if (this.isSelectControl &&
            ((filterItemChange && !filterItemChange.isFirstChange()) ||
                (valueLoaderChange && !valueLoaderChange.isFirstChange()))) {
            this.initValues();
        }
    }
    initValues() {
        if (this.filterItem && this.valueLoader) {
            this.selectValues = this.valueLoader.getCategoryValues(this.filterItem.id)
                .pipe(operators_1.map((values) => {
                return path_processing_helper_1.initComboBoxOptions(values);
            }));
        }
    }
    filterDateTypeChanged(selectedType) {
        this.filterItem.type = selectedType;
    }
    getSinglePickerMessage() {
        return `reporting.controls.page-filter.type.${this.getMessagePostfix()}`;
    }
    getPreviousOptionMessage() {
        return `reporting.controls.page-filter.default-value.previous.${this.getMessagePostfix()}`;
    }
    getCurrentOptionMessage() {
        return `reporting.controls.page-filter.default-value.current.${this.getMessagePostfix()}`;
    }
    getNextOptionMessage() {
        return `reporting.controls.page-filter.default-value.next.${this.getMessagePostfix()}`;
    }
    getCustomOptionMessage() {
        return `reporting.controls.page-filter.default-value.custom.${this.getMessagePostfix()}`;
    }
    getMessagePostfix() {
        if (this.filterItem instanceof week_filter_item_1.WeekFilterItem) {
            return 'week';
        }
        else if (this.filterItem instanceof month_filter_item_1.MonthFilterItem) {
            return 'month';
        }
        else if (this.filterItem instanceof year_filter_item_1.YearFilterItem) {
            return 'year';
        }
        else if (this.filterItem instanceof quarter_filter_item_1.QuarterFilterItem) {
            return 'quarter';
        }
        else if (this.filterItem instanceof semi_annual_filter_item_1.SemiAnnualFilterItem) {
            return 'semi-annual';
        }
        else {
            return 'date';
        }
    }
    // Changes made on Date category brings all default values to custom
    // besides 'ON_OR_BEFORE' and 'ON_OR_AFTER'
    updateDateTypeAndValue(dateValueFrom) {
        if (this.viewMode) {
            const isCustomDate = this.filterItem.dateType !== date_filter_default_value_types_1.DateFilterDefaultValueTypes.ON_OR_BEFORE && this.filterItem.dateType !== date_filter_default_value_types_1.DateFilterDefaultValueTypes.ON_OR_AFTER;
            isCustomDate && this.filterItem.setDateType(date_filter_default_value_types_1.DateFilterDefaultValueTypes.CUSTOM);
        }
        this.filterItem.valueFrom = dateValueFrom;
    }
};
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DateFilterComponent.prototype, "filterItem", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DateFilterComponent.prototype, "isDisabled", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DateFilterComponent.prototype, "showLabel", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DateFilterComponent.prototype, "viewMode", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", idm_filtering_controls_1.ValueLoader)
], DateFilterComponent.prototype, "valueLoader", void 0);
DateFilterComponent = __decorate([
    core_1.Component({
        
        selector: 'sis-date-filter',
        template: require('./date-filter.component.html')
    }),
    __metadata("design:paramtypes", [])
], DateFilterComponent);
exports.DateFilterComponent = DateFilterComponent;
//# sourceMappingURL=date-filter.component.js.map